export const courierDetail =  {
    DHL:{
        key: 'DHL',
        logo: 'DHL.png'
    }
}